module.exports = __webpack_public_path__ + "static/media/sample-excel-card.d186bf76.png";